import { render, staticRenderFns } from "./PersonalizationContacts.vue?vue&type=template&id=ede724a0&scoped=true"
import script from "./PersonalizationContacts.vue?vue&type=script&lang=js"
export * from "./PersonalizationContacts.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationContacts.vue?vue&type=style&index=0&id=ede724a0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede724a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ede724a0')) {
      api.createRecord('ede724a0', component.options)
    } else {
      api.reload('ede724a0', component.options)
    }
    module.hot.accept("./PersonalizationContacts.vue?vue&type=template&id=ede724a0&scoped=true", function () {
      api.rerender('ede724a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/PersonalizationContacts.vue"
export default component.exports